import { assignInlineVars } from "@vanilla-extract/dynamic";
import React from "react";
import { Heading } from "web/react/emo/heading";
import * as styles from "web/react/emo/in-feed-editorial-block/in-feed-editorial-block.css";
import { Text } from "web/react/emo/text";
import { View } from "web/react/emo/view";
import { useArticleAnalytics } from "web/react/hooks/use-article-analytics/use-article-analytics";
import { gettext } from "web/script/modules/django-i18n";
import { ArticleCardSerializer } from "web/types/serializers";

export function PrimaryArticleCard({
    title,
    thumbnails,
    is_sponsored: isSponsored,
    caption,
    article_url: articleUrl,
    slug,
    franchise,
    gender,
    content_type: contentType,
    position,
    is_pinned: isPinned,
}: ArticleCardSerializer): React.ReactElement {
    const { containerRef, sendClickEvent } = useArticleAnalytics({
        category: "editorial_content_card",
        componentType: "editorial_primary_card",
        articleLabel: slug,
        franchise: franchise || null,
        gender,
        position,
        isSponsored,
        contentType: contentType || "editorial",
        isPinned,
    });

    return (
        <div data-testid="editorial-content-card-primary" ref={containerRef}>
            <a href={articleUrl}>
                <View className={styles.primaryArticleContent}>
                    <View
                        onClick={() => sendClickEvent("image")}
                        dataTestId="primary-article-image"
                    >
                        <picture className={styles.flexContainer}>
                            <source media={styles.desktopMedia} srcSet={thumbnails?.landscape.lg} />
                            <source media={styles.mobileMedia} srcSet={thumbnails?.portrait.lg} />
                            <img className={styles.thumbnailMask} src={thumbnails?.landscape.lg} />
                        </picture>
                        <View
                            style={assignInlineVars({ [styles.overlayBackgroundHeight]: "56%" })}
                            className={styles.thumbnailTextOverlayBackground}
                        />
                    </View>
                    <View
                        paddingBottom="md"
                        paddingLeft={{ sm: "sm", md: "md" }}
                        paddingRight={{ sm: "lg_v2", md: "none" }}
                        className={styles.thumbnailTextOverlayContainer}
                        onClick={() => sendClickEvent("cta")}
                        dataTestId="primary-article-cta"
                    >
                        <View marginBottom="sm">
                            {isSponsored && (
                                <View marginBottom="xxs">
                                    <Text textStyle="caption-3" color="information" upperCase>
                                        {gettext("general.sponsored_label")}
                                    </Text>
                                </View>
                            )}
                            <View marginBottom="xxs">
                                <Heading
                                    textStyle="hero-s"
                                    color="information"
                                    wordBreak
                                    lineLimit={2}
                                >
                                    {title}
                                </Heading>
                            </View>
                            <Text textStyle="body-s" color="grayscale400" lineLimit={2}>
                                {caption}
                            </Text>
                        </View>
                        <Text textStyle="body-s-bold" color="information" underline>
                            {gettext("general.read_and_shop")}
                        </Text>
                    </View>
                </View>
            </a>
        </div>
    );
}
